<!-- 我的奖励 -->
<template>
 <div class="container">
   <div class="top-info">
    <div class="top-info_top">
      <span>
        {{getDayGreetings()}}，{{data.partnerName}}
      </span>
      <span>
        <!-- 合伙人等级 -->
        {{ $t('app.label.partnerLevel') }} LV{{ data.partnerLevel }}
      </span>
    </div>
    <div class="top-info_middle">
      <span>
        <!-- 累计获得奖金 -->
        {{ $t('app.label.accumulatedBonus') }}
      </span>
      <span>
        {{ data.totalRewardAmount | money }}
      </span>
    </div>
    <div class="top-info_bottom">
      <div>
        <span>
          <!-- 已结算奖金 -->
         {{ $t('app.label.settlementBonus') }}
        </span>
        <span>
          {{ data.settledRewardAmount | money }}
        </span>
      </div>
      <div>
        <span>
          <!-- 待结算奖金 -->
         {{ $t('app.label.toBeDettledBonus') }}
        </span>
        <span>
          {{ data.waitSettleRewardAmount | money }}
        </span>
        <span>
          <!-- 最近结算日期i -->
          {{ $t('app.sentence.statementOfSettlement') }}
        </span>
      </div>
    </div>
   </div>
    <vanTabs
      v-model="tabActive"
      @change="refresh"
    >
      <!-- 奖励记录 -->
      <vanTab
        :title="$t('app.label.rewardRecord')"
        name="rewardRecord"
        class="tab-item"
      >
        <div class="list-top">
          <div
            class="date-btn"
            @click="openModal"
          >
            {{dateTime | dateYearMon}}
            <vanIcon name="play" size="12"/>
          </div>
          <div
            class="record-total-num"
            @click="$refs.rewardRulesModal.show = true"
          >
            {{ $t('app.label.rewardRuleDescription') }}
          </div>
        </div>
        <vanList
          v-model="rewardRecord.loading"
          :finished="rewardRecord.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in rewardRecord.list"
            :key="item.money"
            class="list-item reward-item"
            @click="toRecordDetail(item, 'reward')"
          >
            <div class="col-item">
              <span class="money-num">{{ item.rewardAmount | money }}</span>
              <!-- 奖励金额 -->
              <span class="small-thin">{{ $t('app.label.rewardAmount') }}</span>
            </div>
            <div>
              <span class="reward-date">{{ item.accountingDate }}</span>
              <vanIcon
                name="arrow"
                color="rgba(255,255,255,0.60)"
                size="11"
              />
            </div>
          </div>
        </vanList>
      </vanTab>
      <!-- 结算记录 -->
      <vanTab
        :title="$t('app.label.settlementRrecord')"
        name="settlementRrecord"
        class="tab-item"
      >
        <div class="list-top">
          <div
            class="date-btn"
            @click="openModal"
          >
            {{dateTime| dateYearMon}}
            <vanIcon name="play" size="12"/>
          </div>
          <div
            class="record-total-num"
            @click="$refs.rewardRulesModal.show = true"
          >
            {{ $t('app.label.rewardRuleDescription') }}
          </div>
        </div>
        <vanList
            v-model="settlementRrecord.loading"
            :finished="settlementRrecord.finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              v-for="item in settlementRrecord.list"
              :key="item.money"
              class="list-item col-item settlement-item"
              @click="toRecordDetail(item, 'settle')"
            >
              <div class="row-item list-item-title-bar">
                <span>
                  <!-- 结算日期 -->
                  {{ $t('app.label.settlementDate') }}：{{ item.settlementDate }}
                </span>
                <span>
                  <!-- 收款名称 -->
                  {{ $t('app.label.collectionName') }}：{{ item.bankAccountName }}
                </span>
              </div>
              <div class="row-item__between">
                <div class="col-item">
                  <span class="money-num">{{ item.settleAmount | money }}</span>
                  <!-- 结算金额 -->
                  <span class="small-thin">{{ $t('app.label.settlementAmount') }}</span>
                </div>
                <div class="row-item align-centenr">
                  <vanIcon
                    name="arrow"
                    color="rgba(255,255,255,0.60)"
                    size="11"
                  />
                </div>
              </div>
            </div>
          </vanList>
      </vanTab>
    </vanTabs>

    <DateTimePicker
      v-model="dateTime"
      ref="dateTimePicker"
      type="year-month"
      title="选择年月"
      :formatter="formatter"
      @confirm="changeTimer"
    />
    <RewardRulesModal
      ref="rewardRulesModal"
    />
 </div>
</template>

<script>
import { getDayGreetings, cloneDeep, session } from '@/utils'
import { apiGet } from '@/services'
import DateTimePicker from '@/components/dateTimePicker'
import RewardRulesModal from '@/components/reward_components/rewardRulesModal'
const defaultData = {
  list: [],
  loading: false,
  finished: false,
  pageSize: 5,
  pageIndex: 1,
  total: 0
}

export default {
  name: 'my-reward-page',
  components: {DateTimePicker, RewardRulesModal},
  data() {
    return {
      defaultData,
      cloneDeep,
      // 区分数据，好做懒加载
      rewardRecord: cloneDeep(defaultData),
      settlementRrecord: cloneDeep(defaultData),
      // 接口
      apiObj: {
        rewardRecord: 'partner/open/reward/record',
        settlementRrecord: 'partner/open/settle/record'
      },
      // 头部信息块
      data: {},
      dateTime: new Date(),
      // 查询条件
      search: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      },
      // tab栏选中项
      tabActive: 'rewardRecord',
      getDayGreetings
    }
  },
  mounted() {
    if (session('myReward')) {
      const { search, dateTime, tabActive } = JSON.parse(session('myReward'))
      this.tabActive = tabActive
      this.search = search
      this.dateTime = new Date(dateTime)
      window.sessionStorage.removeItem('myReward')
    }
    this.get()
    this.getInfo()
  },

  beforeRouteLeave (to, from, next) {
    const { search, dateTime, tabActive } = this
    session('myReward', JSON.stringify({
      tabActive,
      dateTime,
      search
    }))
    next()
  },
  methods: {
    // 查看详情
    toRecordDetail(item, type) {
      // 奖励详情
      if (type === 'reward') {
        this.$router.push({ name: 'reward', params: { accountingDate: item.accountingDate } })
      } else {
        this.$router.push({ name: 'settleRecord', params: { settlementDate: item.settlementDate } })
      }
    },
    // 获取头部个人信息等
    getInfo () {
      apiGet('partner/open/reward').then(res => {
        if (res.code === '0000') {
          this.data = res.data
        } else {
          this.$handleErr(res.msg)
        }
      })
    },
    // 获取奖励记录和结算记录
    get() {
      this[this.tabActive].loading = true
      const data = {
        ...this.search,
        pageIndex: this[this.tabActive].pageIndex,
        pageSize: this[this.tabActive].pageSize
      }
      apiGet(this.apiObj[this.tabActive], data).then((res) => {
        if (res.code === '0000') {
          this[this.tabActive].list = this[this.tabActive].list.concat(res.data)
          this[this.tabActive].total = res.total
          if (this[this.tabActive].pageSize * this[this.tabActive].pageIndex < res.total) {
            this[this.tabActive].finished = false
            this[this.tabActive].pageIndex = this[this.tabActive].pageIndex + 1
          } else {
            this[this.tabActive].finished = true
          }
        } else {
          this.$handleErr(res.msg)
        }
      }).then(() => {
        this[this.tabActive].loading = false
      })
    },
    // 选择时间
    changeTimer(date) {
      this.search.year = date.getFullYear()
      this.search.month = date.getMonth() + 1
      this.refresh()
    },
    // 重置
    refresh() {
      this[this.tabActive] = cloneDeep(this.defaultData)
      this.get()
    },
    // 弹窗
    openModal() {
      this.$refs.dateTimePicker.showPopup()
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    // 瀑布流滚动加载
    onLoad() {
      this.get()
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    background: #121212;
    min-height: calc(100vh - 52px);
  }
  .top-info {
    height: 250px;
    background: url(~@/assets/images/myReward/bg.png);
    background-size: contain;
    box-sizing: border-box;
    padding: 12px 16px 26px;
    color: #fff;
    .top-info_top {
      display: flex;
      flex-direction: row;
      font-size: 14px;
      justify-content: space-between;
      padding-bottom: 44px;
    }
    .top-info_middle {
      display: flex;
      flex-direction: column;
      font-size:14px;
      color: rgba(255, 255, 255, .7);
      padding-bottom: 28px;
      span {
        line-height:20px;
        &:last-child {
          padding-top: 2px;
          font-size:36px;
          color: #fff;
          font-weight:bold;
          line-height:42px;
        }
      }
    }
    .top-info_bottom {
      display: flex;
      flex-direction: row;
      font-size: 12px;
      color: rgba(255, 255, 255, .7);
      & > div {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      span {
        &:nth-child(2) {
          font-size: 20px;
          padding: 4px;
          color: #fff;
          font-weight: bold;
          line-height: 24px;
        }
        &:nth-child(3){
          line-height: 16px;
          color: rgba(255, 255, 255, .5);
        }
      }
    }
  }
  /deep/.van-hairline--top-bottom {
      &::after {
        border-width: 0
      }
    }
  /deep/.van-tabs__line {
    width: 18px !important;
    height:3px;
    background: #ffdd3f;
    border-radius:2px;
  }
  /deep/.van-tab{
    background: #282830;
    color: rgba(255,255,255,0.60);
    .van-tab--active {
      color: #ffffff;
    }
  }
   /deep/.van-tab--active {
    color: #ffffff;
  }
  /deep/.van-tab + .van-tab {
    position: relative;
    &::before {
      content: '';
      display: block;
      width:1px;
      height:18px;
      background: #444757;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .tab-item {
    box-sizing: border-box;
    padding: 12px 16px 20px;
  }
  .list-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    .date-btn {
      width:130px;
      height:40px;
      background: #737992;
      border-radius:20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 14px;
      /deep/.van-icon-play {
        transform: rotate(90deg);
        padding-bottom: 6px;
      }
    }
    .record-total-num {
      font-size:12px;
      color: rgba(255,255,255,0.40);
    }
  }
  .list-item {
    background: #282830;
    border-radius:2px;
    display: flex;
    padding: 12px;
    margin-bottom: 10px;
    .money-num {
      font-size:22px;
      font-weight:bold;
      font-size:22px;
      color: rgba(255,255,255,0.86);
    }
    .small-thin {
      color: rgba(255,255,255,0.40);
      font-size:12px;
      line-height:17px;
    }
    .reward-date {
      font-size:14px;
      color: rgba(255,255,255,0.60);
    }
    /deep/.van-icon {
      padding-left: 10px;
    }
  }
  .reward-item {
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
  }
  .settlement-item {
    padding: 8px 0;
    .list-item-title-bar {
      padding: 0 12px 8px;
      font-size:12px;
      color:rgba(160,167,189,1);
      border-bottom: 1px solid #444757;
      span:first-child {
        padding-right: 20px;
      }
    }
    /deep/.row-item__between {
      box-sizing: border-box;
      padding: 10px 12px 2px;
    }
  }
  .invite-btn-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 32px;
    .invite-btn {
      width:223px;
      height:44px;
      background:linear-gradient(90deg,rgba(118,210,255,1) 0%,rgba(31,122,255,1) 100%);
      border-radius:22px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size:16px;
      color:rgba(255,255,255,1);
    }
  }
</style>
